import React, {Component} from 'react';
import './Spine.css';
import Avatar from '../widgets/Avatar';
import {Link} from 'react-router-dom';
import RouteTreeLink from '../widgets/RouteTreeLink';
import RouteLink from '../widgets/RouteLink';
import {connect} from 'react-redux';
import Button from '../widgets/Button';
import {admin_syllabus, admin_user} from '../permissions';

export class Spine extends Component {
	render() {
		const {session, isDirty, logout} = this.props;
		
		return (
			<nav className={`Spine ${isDirty ? 'dirty' : ''}`}>
				{isDirty ? (
					<span className='Spine-logo'><img src='//demo.seqta.com.au/js/images/seqta-spine.png' /></span>
				) : (
					<Link to='/' className='Spine-logo'><img src='//demo.seqta.com.au/js/images/seqta-spine.png' /></Link>
				)}
				
				<spacer />
				{session && session.permissions && session.permissions.indexOf(admin_syllabus) >= 0 ? (<RouteTreeLink
					disabled={isDirty}
					className="Spine-page"
					to="/"
					matches={[
						'/',
						'/set'
					]}
				>Syllabus</RouteTreeLink>) : undefined}
				{session && session.permissions && session.permissions.indexOf(admin_user) >= 0 ? (
					<RouteLink disabled={isDirty} className="Spine-page" to='/user'>Users</RouteLink>
				) : undefined}
				<spacer />
				{session ? (
					<div className="Spine-session logged-in" title={`${session.firstname} ${session.lastname}`}>
						<Avatar imagePath={session.imagePath} />
						<div className="Spine-session-name">{session.firstname} {session.lastname}</div>
						<div className="Spine-session-actions">
							<Button className="Spine-session-logout" disabled={isDirty} onClick={logout}>Log out</Button>
						</div>
					</div>
				) : (
					<div className="Spine-session logged-out">Not logged in</div>
				)}
			</nav>
		);
	}
}

const ConnectedSpine = connect(
	state => ({
		isDirty: !!(state.dirty && state.dirty.keys && Object.keys(state.dirty.keys).length),
		location: state.router && state.router.location && state.router.location.pathname, // Ensure re-render on route change
		session: state.session
	})
)(Spine);

export default ConnectedSpine;


// WEBPACK FOOTER //
// ./src/chrome/Spine.js